<!-- 				-->
<!-- Confirm Dialog -->
<!-- 				-->
<p-confirmDialog [style]="{ width: '400px' }" [baseZIndex]="10000"></p-confirmDialog>

<div class="main-top-group">
	<!--  	   	 	 -->
	<!-- TOP SECTION -->
	<!-- 			 -->
	<div class="column-group">
		<div class="column1">
			<!-- 	   -->
			<!-- Title -->
			<!-- 	   -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Title</label>
				</div>

				<div style="margin-left: 10px">
					<input type="text" pInputText [(ngModel)]="rIncidentImageTitle" maxlength="100" style="width: 350px" />
				</div>

				<div>
					<label class="column-item-label">Max 100 characters</label>
				</div>
			</div>

			<!-- 	     -->
			<!-- Comment -->
			<!-- 	     -->
			<div class="column-item">
				<div>
					<label class="column-item-label">Comment</label>
				</div>

				<div style="margin-left: 10px">
					<textarea
						pInputTextarea
						[(ngModel)]="rIncidentImageComment"
						style="width: 350px; min-width: 350px; max-width: 350px; height: 150px; min-height: 150px; max-height: 350px"
					></textarea>
				</div>

				<div>
					<label class="column-item-label">Max 2,000 characters</label>
				</div>
			</div>
		</div>
	</div>
</div>

<!--				-->
<!-- Error Message  -->
<!--				-->
<div class="main-error-group" [style.display]="ErrorMessage.length == 0 ? 'none' : 'block'">
	<div class="error-div">
		<label class="error-message">{{ ErrorMessage }}</label>
	</div>
</div>

<!-- 		 -->
<!-- Buttons -->
<!-- 		 -->
<div style="margin-top: 20px">
	<button class="btn btn-primary" style="margin-left: 0px" (click)="onAddUpdate()" [disabled]="isBusy == true">Ok</button>
	<button class="btn btn-primary" style="margin-left: 5px" (click)="onClose()">Cancel</button>
</div>
